module.exports = __webpack_public_path__ + "img/backends.23c3cd1f.png";